import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useGetTerminal } from '@dhl/mdp-api'

import { Box, Grid } from '@dhl-ui/components'
import { links } from '~/AppRoutes'
import { AccountDataTable } from '~/common/components/accountnumbers'
import { useNavigateWithSearchString } from '~/common/hooks'
import { convertToOrganisation } from '~/modules/organisations/model'

import { TerminalDetails } from '~/modules/terminals/components'
import { BackButton } from '~/temp-ds-component/BackButton'

type Params = {
  id: string
}

export const TerminalDetailsPage = () => {
  const { id } = useParams<Params>()
  const navigateWithSearchString = useNavigateWithSearchString(true)
  const { t } = useTranslation()
  const { data: terminalDto, isFetching } = useGetTerminal(id || '', { query: { enabled: !!id } })

  const onBack = () => navigateWithSearchString(links.terminalsLink())

  return isFetching || !terminalDto ? null : (
    <>
      <Grid>
        <Box marginBottom={2}>
          <BackButton onClick={onBack}>{t('admin.terminalsPage.terminalForm.backButtonTitle')}</BackButton>
        </Box>
      </Grid>
      <Grid container direction="row" spacing={2}>
        <Grid size={{ xs: 6 }}>{terminalDto && <TerminalDetails values={terminalDto} />}</Grid>
        {id && (
          <Grid size={{ xs: 6 }}>
            <AccountDataTable organisation={convertToOrganisation(terminalDto)} businessType={'terminal'} />
          </Grid>
        )}
      </Grid>
    </>
  )
}
